(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["career-section"] && !Shopify.designMode) return;
  try {
    
  function initializePositionItems() {
    let questions = document.querySelectorAll('.position-item__header');

    questions.forEach((question) => {
      question.addEventListener('click', (event) => {
        const isActive = question.classList.contains('active');
        questions.forEach((q) => {
          q.classList.remove('active');
          q.nextElementSibling.style.maxHeight = 0;
        });

        if (!isActive) {
          question.classList.add('active');
          const answer = question.nextElementSibling;
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initializePositionItems);
  document.addEventListener('shopify:section:load', initializePositionItems);
  document.addEventListener('shopify:section:reorder', initializePositionItems);

  } catch(e) { console.error(e); }
})();
})();
